<template>
  <div class="dashboard-layout h-screen flex">
    <Sidebar :collapsed="sidebarCollapsed" />
    
    <div class="flex-1 flex flex-col overflow-hidden">
      <Header 
        title="Access Restricted" 
        :showSearch="false" 
        :showMenuToggle="true" 
        @toggle-sidebar="toggleSidebar"
      />
      
      <!-- Main Content -->
      <main class="flex-1 overflow-auto bg-gray-100 dark:bg-gray-800 p-6 transition-all duration-300">
        <div class="max-w-2xl mx-auto">
          <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
            <div class="text-center">
              <i class="fas fa-lock text-6xl text-primary-600 dark:text-primary-400 mb-4"></i>
              <h2 class="text-3xl font-bold text-gray-900 dark:text-white">Access Restricted</h2>
              <p class="mt-2 text-gray-600 dark:text-gray-300">
                You don't have permission to access this page. This feature is only available to administrators.
              </p>
              <div class="mt-6">
                <router-link 
                  to="/dashboard" 
                  class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                >
                  <i class="fas fa-arrow-left mr-2"></i>
                  Return to Dashboard
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Header from '../components/Header.vue';
import Sidebar from '../components/Sidebar.vue';

const sidebarCollapsed = ref(false);

const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value;
};
</script> 